import React, { useState, useEffect, useRef } from 'react';
import { formatDate, isSameDate } from '../../utils/dateUtils';

function DatePickerCalendar({ selectedDate, onSelect, onClose, isDateDisabled }) {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const calendarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const renderCalendar = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());

    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
    const monthNames = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];

    const days = [];
    const currentDate = new Date(startDate);
    const today = new Date();

    for (let i = 0; i < 42; i++) {
      const isCurrentMonth = currentDate.getMonth() === month;
      const dateStr = formatDate(currentDate);
      const isSelected = selectedDate === dateStr;
      const isToday = isSameDate(currentDate, today);
      const isDisabled = isDateDisabled(new Date(currentDate));

      days.push({
        date: new Date(currentDate),
        dateStr,
        isCurrentMonth,
        isSelected,
        isToday,
        isDisabled
      });

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return (
      <div className="calendar-popup active" ref={calendarRef}>
        <div className="calendar-header">
          <button
            type="button"
            className="calendar-nav-btn"
            onClick={() => {
              const newMonth = new Date(currentMonth);
              newMonth.setMonth(newMonth.getMonth() - 1);
              setCurrentMonth(newMonth);
            }}
          >
            ‹
          </button>
          <div className="calendar-month-year">
            {year}年{monthNames[month]}
          </div>
          <button
            type="button"
            className="calendar-nav-btn"
            onClick={() => {
              const newMonth = new Date(currentMonth);
              newMonth.setMonth(newMonth.getMonth() + 1);
              setCurrentMonth(newMonth);
            }}
          >
            ›
          </button>
        </div>
        <div className="calendar-grid">
          {weekdays.map((day) => (
            <div key={day} className="calendar-day-header">
              {day}
            </div>
          ))}
          {days.map((day, idx) => {
            let classes = 'calendar-day';
            if (!day.isCurrentMonth) classes += ' other-month';
            if (day.isSelected) classes += ' selected';
            if (day.isToday) classes += ' today';
            if (day.isDisabled) classes += ' disabled';

            return (
              <div
                key={idx}
                className={classes}
                onClick={() => {
                  if (!day.isDisabled && day.isCurrentMonth) {
                    onSelect(day.dateStr);
                  }
                }}
              >
                {day.date.getDate()}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return renderCalendar();
}

export default DatePickerCalendar;

